//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'CourseDetailsDialog',

	props: {
		course: {
			type: Object,
			required: true,
		},
	},

	computed: {
		createdDate() {
			return this.$dayjs(this.course.created_at).format('MMM DD, YYYY');
		},
	},

	methods: {
		async openUrl() {
			await this.$store.dispatch('courses/recordsCourseView', this.course.uuid);

			this.$emit('close-modal');

			window.open(this.course.url, '_blank', 'noopener,noreferrer');
		},
	},
}
